import { PROXY_CONFIG_AUTOCOMPLETE } from "Config/ProxyConfig";
import debounce from "lodash.debounce";
// import PlacesAutocomplete from "react-places-autocomplete";
import useTranslation from "next-translate/useTranslation";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingReducerSelectors,
} from "redux/slices/v2/ListingReducer";
import { RootState } from "types/RootState";
import { decrypt } from "utils/CRYPTO/secret";
import styles from "utils/PlacesAutocomplete/PlacesAutocomplete.module.css";
import DefaultSearchList from "../DefaultSearchList";
import DotLoading from "./DotLoading";
import $ from "utils/selectors";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import { capitaliserPremiereLettre } from "utils/Functions";

declare global {
  interface Window {
    cartedesprix: any;
    cartedesannonces: any;
    google: any;
  }
}
declare var google: any;
export default function PlacesAutoCompleteInput({
  onMapSearchParamsChange,
  onPlaceSearchResult,
  onGeolocatePress,
  showSearchInputField,
  specialClassNames,
  onMapVsListChange,
  onAdressChange,
  defaultAdress,
  lang = "ar",
}: {
  onMapSearchParamsChange: (
    mapState: RootState["listingsV2"]["mapState"]
  ) => void;
  onPlaceSearchResult: ({
    region,
    province,
    commune,
    zoom,
    lat,
    lng,
    quartier,
    shortName,
    adresse,
  }: {
    region?: string;
    province?: string;
    commune?: string;
    zoom?: any;
    lat?: any;
    lng?: any;
    quartier?: any;
    shortName?: any;
    adresse?: any;
  }) => void;
  onGeolocatePress: () => void;
  showSearchInputField: boolean;
  specialClassNames?: any;
  onMapVsListChange?: any;

  onAdressChange?: any;
  defaultAdress?: any;
  lang?: string;
}) {
  const { t } = useTranslation("commonAnnonces");
  const t2 = useTranslation("annonceAchat").t;
  const dispatch = useDispatch();
  const options = {
    componentRestrictions: { country: "MA" },
    fields: ["address_components", "geometry", "icon", "name"],
    strictBounds: false,
    // types: ["establishment"],
  };
  let autocomplete = null;
  const inputRef = useRef<HTMLInputElement>(null);
  const listingsLoading = useSelector(ListingReducerSelectors.loadingSelactor);
  const [rechercheType, setRechercheType] = useState("AGENZ");
  const [suggestionsAgenz, setSuggestionsAgenz] = useState([]);
  const [loadingAgenz, setLoadingAgenz] = useState(false);
  const [firstSetAddresse, setFirstSetAdresse] = useState(false);
  const currentLocationAddress = useSelector(
    ListingReducerSelectors.currentLocationAddressSelactor
  );

  const [address, setAddress] = useState<string>(
    defaultAdress ? defaultAdress : ""
  );
  const [addressURL, setAddressURL] = useState<string>("");
  const [
    currentLocationSuggestionVisible,
    setCurrentLocationSuggestionVisible,
  ] = useState<boolean>(false);
  const firstUpdateSpinner = useRef(true);
  const firstUpdateCLAdresse = useRef(true);
  const firstUpdateAdresse = useRef(true);

  useEffect(() => {
    setCurrentLocationSuggestionVisible(false);
  }, []);
  const onAgenzSuggestionSelected = async (suggestion) => {
    setSuggestionsAgenz([]);
    setCurrentLocationSuggestionVisible(false);
    dispatch(ListingreducerActions.setloading({ loading: true }));
    if (onAdressChange) {
      onAdressChange(suggestion.description);
    }
    setAddress(suggestion.description);

    if (
      suggestion.box
      // suggestion.niveau !== "provinces" &&
      // suggestion.niveau !== "communes" &&
      // suggestion.niveau != "region"
    ) {
      let firstlat = Math.max(suggestion.box[0][1], suggestion.box[0][0]);
      let secondlat = Math.max(suggestion.box[1][1], suggestion.box[1][0]);
      let firstlng = Math.min(suggestion.box[0][1], suggestion.box[0][0]);
      let secondlng = Math.min(suggestion.box[1][1], suggestion.box[1][0]);

      dispatch(
        ListingreducerActions.setSearchPayload({
          searchPayload: {
            bounds: {
              _ne: {
                lat: Math.max(firstlat, secondlat),
                lng: Math.min(firstlng, secondlng),
              },
              _sw: {
                lat: Math.min(firstlat, secondlat),
                lng: Math.max(firstlng, secondlng),
              },
            },
            lat: Math.min(
              suggestion.center.coordinates[1],
              suggestion.center.coordinates[0]
            ),

            lng: Math.max(
              suggestion.center.coordinates[1],
              suggestion.center.coordinates[0]
            ),
            province:
              (suggestion.niveau === "provinces" ||
                suggestion.niveau === "communes" ||
                suggestion.niveau === "pas") &&
                suggestion.province
                ? suggestion.province
                : null,
            commune:
              (suggestion.niveau === "communes" ||
                suggestion.niveau === "pas") &&
                suggestion.commune
                ? suggestion.commune
                : null,
            quartier:
              (suggestion.niveau === "communes" ||
                suggestion.niveau === "pas") &&
                suggestion.quartier
                ? suggestion.quartier
                : null,
            zoom: suggestion.zoom ? suggestion.zoom : 15,
            address: suggestion.description,
            no_trigger_search: false,
          },
        })
      );

      onMapSearchParamsChange({
        preventZoomEndAction:
          suggestion.zoom < 13 && !suggestion.commune ? true : false,
        center: {
          lat: Math.max(
            suggestion.center.coordinates[1],
            suggestion.center.coordinates[0]
          ),
          lng: Math.min(
            suggestion.center.coordinates[1],
            suggestion.center.coordinates[0]
          ),
        },
        zoom: suggestion.zoom > 14.5 ? 14 : suggestion.zoom,
        speed: suggestion.speed,
      });
      dispatch(
        ListingreducerActions.setMapState({
          mapState: {
            preventZoomEndAction: false,
            center: {
              lat: Math.min(
                suggestion.center.coordinates[1],
                suggestion.center.coordinates[0]
              ),

              lng: Math.max(
                suggestion.center.coordinates[1],
                suggestion.center.coordinates[0]
              ),
            },
            zoom: suggestion.zoom > 14.5 ? 14 : suggestion.zoom,
            speed: 3,
          },
        })
      );
    }

    if (suggestion.source == "google_maps") {
      try {
        await api_call_v2(undefined, "post", "autocomplete/update", {
          data: {
            ...suggestion,
            geometry: null,
            priority: suggestion.niveau == "pas" ? 4 : 3,
            source: "recherche_google_maps",
            search_field: `${address.toLowerCase()} ${suggestion.description
              .toLowerCase()
              .normalize("NFD")
              .replace(/&/g, " ")
              .replace(/-/g, " ")
              .replace(/_/g, " ")
              .replace(/,/g, " ")
              .replace(".", " ")
              .replace(/;/g, " ")
              .replace(/:/g, " ")
              .replace(/'/g, " ")
              .replace(/"/g, " ")
              .replace(/[\u0300-\u036f]/g, "")}`,
          },
        });
      } catch (e) { }
    }
    dispatch(ListingreducerActions.setloading({ loading: false }));
  };

  const handleChangeResult = async (value) => {
    if (firstSetAddresse) {
      setFirstSetAdresse(false);
      return;
    }
    setSuggestionsAgenz([]);
    if (value) {
      setLoadingAgenz(true);
      api_call_v2(
        undefined,
        "get",
        "autocomplete/places/box",
        {
          params: {
            search: value,
            lang: lang,
          },
        },
        "autocomplete"
      )
        .then((res) => {
          let results = decrypt(res.data).results.map((item) => {
            if (item.niveau == "communes" && !item.commune) {
              item.niveau == "pas";
            }
            if (lang == "ar") {
              item.description_ar
                ? (item.description = item.description_ar
                  .split(", ")
                  .map((word) => {
                    return t2(capitaliserPremiereLettre(word.toLowerCase()));
                  })
                  .join(", "))
                : (item.description = item.description
                  .split(", ")
                  .map((word) => {
                    return t2(capitaliserPremiereLettre(word.toLowerCase()));
                  })
                  .join(", "));
            } else if (lang == "en") {
              item.description_en
                ? (item.description = item.description_en
                  .split(", ")
                  .map((word) => {
                    return t2(capitaliserPremiereLettre(word.toLowerCase()));
                  })
                  .join(", "))
                : (item.description = item.description
                  .split(", ")
                  .map((word) => {
                    return t2(capitaliserPremiereLettre(word.toLowerCase()));
                  })
                  .join(", "));
            }
            return item;
          });

          setSuggestionsAgenz(
            results.map((item) => {
              return { ...item };
            })
          );
          try {
            $("#react-suggestions-1").css("z-index", "100");
          } catch (e) { }
          setLoadingAgenz(false);
        })
        .catch((err) => {
          setLoadingAgenz(false);
        });
    } else {
      setLoadingAgenz(false);
    }
  };

  const debouncedResults = useCallback(
    debounce((value) => {
      handleChangeResult(value);
    }, 400),
    []
  );

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const [spinnerLoading, setSpinnerLoading] = useState<boolean>(false);

  useEffect(() => {
    setSpinnerLoading(listingsLoading);
  }, [listingsLoading]);

  useEffect(() => {
    debouncedResults(address);
  }, [address]);

  const [defaultSearchList, setDefaultSearchList] = useState(false);
  const [searchBarFull, setSearchBarFull] = useState(false);
  const [borderColor, setBorderColor] = useState(false);

  const popupRef = useRef(null);

  const handleAdress = (value, data) => {
    onAgenzSuggestionSelected(data);
  };

  const dropProperty = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropProperty.current &&
        !dropProperty.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setDefaultSearchList(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const suggestionRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionRef.current &&
        !suggestionRef.current.contains(event.target)
      ) {
        setSuggestionsAgenz([]);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      id="search-bar-inputAutoComplet"
      className={`${styles.search__bar__input___lp_container} ${showSearchInputField && styles.search__bar__input___lp_container_visible
        } ${specialClassNames === "in_listings"
          ? styles.search__bar__input___lp_container__in_listings
          : ""
        } 
    ${searchBarFull ? styles.NewMobileFull : ""}
      `}
    >
      <div
        id="search_form_annonce"
        style={{ height: searchBarFull ? "auto" : "100%", zIndex: 1000 }}
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className={`${styles.pa__form}`}
      >
        <div className={styles.pa115_search_bar}>
          <div
            className={`${styles.pa115_search_bar__button} ${styles.pa115_search_bar__buttonNew}`}
          >
            {searchBarFull ? (
              <>
                <span
                  className={styles.backIcon}
                  onClick={() => {
                    setSearchBarFull(false);
                  }}
                >
                  <svg
                    width="20"
                    height="16"
                    viewBox="0 0 20 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 15L1 8M1 8L8 1M1 8L19 8"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </>
            ) : null}
            {address && (
              <span
                onClick={() => {
                  setAddress("");
                }}
                className={styles.empty}
                style={{
                  color: "#000",
                  // width: "16px",
                  // height: "16px",
                  // top: "23px !important",
                  zIndex: 1000,
                  right: "14px",
                }}
              >
                <i className={"fas fa-times"} />
              </span>
            )}
            {spinnerLoading ? (
              <div
                style={{ top: "12px !important", zIndex: 1000 }}
                className={`${specialClassNames === "in_listings"
                  ? styles.hide_in_listings_mobile
                  : ""
                  }`}
              >
                <i className="fas fa-circle-notch fa-spin"></i>
              </div>
            ) : !address ? (
              <div
                className={`${specialClassNames === "in_listings"
                  ? styles.hide_in_listings_mobile
                  : ""
                  }`}
                style={{
                  color: "#000",
                  width: "16px",
                  height: "16px",
                  zIndex: 1000,
                }}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.5 17.5L12.5 12.5M14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z" stroke="#4609F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            ) : null}
            <div
              className={`${styles.pa115_input__form__search}`}
              style={{
                border: !borderColor && address ? "1px solid #00111A" : "",
              }}
            >
              <input
                name="recherche"
                aria-label="Suggestions de recherches"
                ref={inputRef}
                value={address ? address : addressURL ? addressURL : ""}
                style={{
                  minHeight: "40px !important",
                  backgroundColor: "white",
                  width: "100%",
                  height: "100%",
                  border: "0px",
                }}
                className={`${styles.search__bar__input__lp_40} ${specialClassNames === "in_listings"
                  ? styles.search_bar_in_lisings
                  : ""
                  }`}
                type="text"
                onFocus={(e) => {
                  e.preventDefault();
                  setBorderColor(true);
                  if (e.target.value === "") setDefaultSearchList(true);
                  setSearchBarFull(true);
                }}
                autoComplete="off"
                onChange={(e) => {
                  if (e.target.value !== "") setDefaultSearchList(false);
                  else setDefaultSearchList(true);
                  if (onAdressChange) {
                    onAdressChange(e.target.value);
                  }
                  setAddress(e.target.value);
                  setAddressURL("");
                }}
                onBlur={() => {
                  setBorderColor(false);
                }}
                placeholder={t("Entrez une ville, un quartier , une adresse")}
              />
            </div>
          </div>
          <div
            className={
              searchBarFull
                ? styles.pa115_search__resultsFull
                : styles.pa115_search__results
            }
            style={{
              // minWidth: '400',
              // top: "44px",
              zIndex: 1000,
            }}
          >
            {loadingAgenz && (
              <div className={styles.pa115_search__results__item}>
                <div className={styles.pa115_search__results__item__inner}>
                  {/* <p className={styles.search__results__suggestion}>
                    Chargement
                  </p> */}
                  <div className={styles.search__results__suggestion}>
                    <DotLoading />
                  </div>
                </div>
              </div>
            )}
            {defaultSearchList ? (
              <div className={styles.pa115_search__results__inner}>
                <div
                  className={styles.pa115_search__results__item}
                  ref={dropProperty}
                >
                  <DefaultSearchList
                    handleAdress={handleAdress}
                    annonces={searchBarFull}
                    setSearchBarFull={setSearchBarFull}
                    setDefaultSearchList={setDefaultSearchList}
                  />
                </div>
              </div>
            ) : null}
            {address ? (
              <div
                className={styles.pa115_search__results__inner}
                ref={suggestionRef}
              >
                {/* {currentLocationSuggestionVisible && (
                  <div
                    role="option"
                    onMouseDown={() => {
                      setSpinnerLoading(true);
                      onGeolocatePress();
                    }}
                    className={styles.pa115_search__results__item}
                  >
                    <p className={styles.search__results__suggestion}>
                      <i
                        aria-hidden
                        className="fa-regular fa-location-dot"
                        style={{
                          marginLeft: "0px",
                          color: "rgba(0, 0, 0, 0.4)",
                        }}
                      ></i>
                      {t("Localisation actuelle")}{" "}
                    </p>
                  </div>
                )} */}

                {!defaultSearchList &&
                  suggestionsAgenz.map((suggestion, index) => {
                    const style = {
                      backgroundColor: suggestion.active
                        ? "#ddd"
                        : "transparent",
                    };
                    return (
                      <div
                        role="option"
                        aria-selected={true}
                        id={`suggestion__item__${index + 1}`}
                        className={styles.pa115_search__results__item}
                        onClick={() => {
                          onAgenzSuggestionSelected(suggestion);
                          setSearchBarFull(false);
                        }}
                      >
                        <div
                          className={styles.pa115_search__results__item__inner}
                        >
                          <p className={styles.search__results__suggestion}>
                            {suggestion.description}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
